var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-button",
    _vm._g(
      {
        ref: "button",
        attrs: {
          block: _vm.block,
          disabled: _vm.disabled,
          size: _vm.size,
          variant: _vm.variant,
          type: _vm.type,
          tag: _vm.tag,
          pressed: _vm.pressed,
          href: _vm.href,
          rel: _vm.rel,
          target: _vm.target,
          active: _vm.active,
          to: _vm.to,
          append: _vm.append,
          replace: _vm.replace,
          event: _vm.event,
          activeClass: _vm.activeClass,
          exact: _vm.exact,
          exactActiveClass: _vm.exactActiveClass,
          routerTag: _vm.routerTag,
          noPrefetch: _vm.noPrefetch
        }
      },
      _vm.$listeners
    ),
    [
      _c("i", {
        staticClass: "far",
        class: ((_obj = {}), (_obj["fa-" + _vm.icon] = true), _obj)
      }),
      _vm._v(" "),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                !_vm.minimizeOn ||
                !_vm.icon ||
                _vm.minimizeOn < _vm.$display.clientWidth,
              expression:
                "!minimizeOn || !icon || minimizeOn < $display.clientWidth"
            }
          ]
        },
        [_vm._t("default", [_vm._v(_vm._s(_vm.text))])],
        2
      ),
      _vm._v(" "),
      _vm.text && !(_vm.minimizeOn < _vm.$display.clientWidth)
        ? _c("b-tooltip", {
            attrs: {
              target: function() {
                return _vm.$refs["button"]
              },
              title: _vm.text
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }